import { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Input, InputRef } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import payeaseStore from '../../stores/payease.store';
import { cx, formatPrice } from '../../payease.utils';
import { PaymentMethod } from '../../payease.types';
import { PayEaseModal } from '../ui/payease-modal/payease-modal';
import { Field } from '../ui/field/field';
import './collect-cash-modal.scss';

export const CollectCashModal = observer(() => {
  const inputRef = useRef<InputRef>(null);
  const isSufficient = payeaseStore.isCashSufficient;

  return (
    <PayEaseModal
      open={payeaseStore.cashModalOpen}
      onClose={() => payeaseStore.closeCashModal()}
      afterOpenChange={(open) => open && inputRef.current?.focus()}
      title="Collect Cash"
      subtitle="Enter the cash amount tendered by the customer.">
      <div className="collect-cash">
        <div className="collect-cash__total collect-cash__total--due">
          <span className="collect-cash__label">Amount due</span>
          <span className="collect-cash__amount">{formatPrice(payeaseStore.effectiveAmount)}</span>
        </div>

        <Field label="Cash Tendered" htmlFor="payease-cash-tendered">
          <Input
            ref={inputRef}
            id="payease-cash-tendered"
            className="collect-cash__input"
            type="number"
            inputMode="decimal"
            step="0.01"
            min={0}
            autoComplete="off"
            placeholder="0.00"
            value={payeaseStore.cashTendered}
            onChange={(event) => payeaseStore.setCashTendered(event.target.value)}
            onPressEnter={() => payeaseStore.completeCashSale()}
          />
          <div className="collect-cash__quick">
            {payeaseStore.quickCashAmounts.map((amount) => (
              <Button key={amount} className="collect-cash__quick-btn" onClick={() => payeaseStore.setCashTendered(amount.toFixed(2))}>
                {formatPrice(amount)}
              </Button>
            ))}
          </div>
        </Field>

        <div className="collect-cash__total collect-cash__total--change">
          <span className="collect-cash__label">Change due</span>
          <span className={cx('collect-cash__amount', isSufficient ? 'collect-cash__amount--accent' : 'collect-cash__amount--muted')}>
            {formatPrice(payeaseStore.changeDue)}
          </span>
        </div>

        <Button
          type="primary"
          block
          className="collect-cash__complete"
          icon={<CheckCircleOutlined />}
          loading={payeaseStore.submittingMethod === PaymentMethod.Cash}
          disabled={!isSufficient || payeaseStore.submitting}
          onClick={() => payeaseStore.completeCashSale()}>
          Complete Sale
        </Button>
      </div>
    </PayEaseModal>
  );
});
